import React, { Fragment } from 'react';
import Counter from '../widgets/Counter';
import Controller from '../widgets/Controller';
import Sensor from '../widgets/Sensor';
import AlertAccent from '../components/AlertAccent';

import 'react-toastify/dist/ReactToastify.css';
import { useDevicesStore } from '../stores';
import TitleWithIcon from '../components/TitleWithIcon';
import GroupForm from '../features/GroupDevices/GroupForm';
import { useFetchDevices } from '../stores/use-fetch-devices';

const DeviceWidgets = {
  counter: Counter,
  controller: Controller,
  sensor: Sensor,
};

const groupByType = (objectDevices) => {
  return objectDevices.reduce((acc, dev) => {
    const key = dev.description;
    if (!acc[key]) acc[key] = [];
    acc[key].push(dev);
    return acc;
  }, {});
};

const Dashboard = () => {
  const { groupDevices, loading } = useDevicesStore();
  useFetchDevices();

  return (
    <div className="sm:flex min-h-screen items-start justify-center bg-gradient-to-r p-2 sm:p-4 from-[#ededed] to-[#dcdcdc]">
      {loading ? null : groupDevices?.length !== 0 ? (
        <div>
          <TitleWithIcon title={'Состояние устройств'}>
            <GroupForm />
          </TitleWithIcon>
          <div>
            {groupDevices.map((object) => {
              const objectDevices = object.devices || [];
              const groupedDevices = groupByType(objectDevices);
              const timeZone = object?.object_time_zone;

              return (
                <div key={object?.object_id}>
                  <h2 className="text-xl sm:text-2xl font-medium my-4">
                    {object?.object_address}, кв {object?.object_apartment ?? ''}
                  </h2>

                  {Object.entries(groupedDevices).map(([typeKey, groupDevices]) => {
                    return (
                      <Fragment key={typeKey}>
                        <p className="text-start text-2xl my-3">{typeKey}</p>

                        <div className="grid grid-cols-1 gap-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 w-full">
                          {groupDevices.map((device, index) => {
                            return (
                              typeof DeviceWidgets[device.type.key] !== 'undefined' &&
                              typeKey === device.description &&
                              React.createElement(DeviceWidgets[device.type.key], {
                                key: index,
                                device: device,
                                timeZone: timeZone,
                              })
                            );
                          })}
                        </div>
                      </Fragment>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="bg-white shadow-2xl rounded-3xl px-6 pb-6 m-2">
          <div className="w-sm mt-6">
            <AlertAccent
              title="Устройства не добавлены!"
              text="Для управления и отображения информации Вам необходимо добавить хотя бы одно устройство"
              showAlert={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
